import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { MoneyModel } from './MoneyModel';
export class ReferralModel {
    static fromDTO(input) {
        return new ReferralModel(input.referralLink, MoneyModel.fromDTO(input.creditsEarned));
    }
    creditsEarnedFormatted() {
        return this.creditsEarned.display();
    }
    referralLink() {
        return this._referralLink;
    }
    constructor(_referralLink, creditsEarned){
        _define_property(this, "_referralLink", void 0);
        _define_property(this, "creditsEarned", void 0);
        this._referralLink = _referralLink;
        this.creditsEarned = creditsEarned;
    }
}
